import deleteIcon from "../../assets/images/trash-03.svg";
import ddnIcon from "../../assets/images/ddn.svg";
import editIcon from "../../assets/images/edit_btn.svg";
import viewIcon from "../../assets/images/eye-02.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  deleteImpactStory,
  fetchImpactStoryList,
} from "../../action/impact-story";
import Pagination from "../../components/pagination/paginationView";
import moment from "moment";
import showNotification from "../../components/notification/showNotification";
import { Modal } from "react-bootstrap";

const ImpactStory = () => {
  const navigate = useNavigate();
  const [stories, SetStories] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [showModel, setShowModel] = useState(false);
  const [selectedStory, setSelectedStory] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const fetchStoryList = async () => {
    setTotalData(0);
    setIsLoading(true);
    const response = await fetchImpactStoryList(pageNo, pageSize);
    if (response.status) {
      SetStories(response?.data?.list);
      setTotalData(response?.data?.count);
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const res = await deleteImpactStory(selectedStory);
      if (res?.status) {
        showNotification(
          "Success",
          res.message || "Impact Story deleted successfully",
          "success"
        );
        fetchStoryList();
      }
    } catch (error) {
     showNotification("Error", error.message || "Failed to delete Story", "danger");
    }
    setShowModel(false);
  };

  useEffect(() => {
    fetchStoryList();
  }, [pageNo, pageSize]);
  return (
    <div>
      <div className="payout_data-head-top">
        <div className="payout_data-left p-0">
          <div className="payout_data_ttl1">Impact Story</div>
        </div>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/impact-story/add")}
        >
          Add New Story
        </button>
      </div>
      <div className="table-responsive">
        <table className="payout_table upi-mandate_table">
          <thead>
            <tr className="tableHead">
              <th className="thHeader">Title</th>
              <th className="thHeader">Total Slides</th>
              <th className="thHeader">Last Updated</th>
              <th className="thHeader">Actions</th>
            </tr>
          </thead>
          <tbody>
            {stories &&
              stories.map((s, i) => {
                return (
                  <tr style={{ cursor: "pointer" }} key={i}>
                    <td>
                      <span className="ellipsis">
                        {s.assets[0]?.title || "-"}
                      </span>
                    </td>
                    <td>{s?.assets?.length || 0}</td>
                    <td>{moment(s.createdAt).format("YYYY/MM/DD  h:mm a")}</td>
                    <td>
                      <button
                        type="button"
                        className="edit-btn"
                        title="Edit"
                        onClick={() => {
                          navigate(`/impact-story/edit/${s._id}`);
                        }}
                      >
                        <img alt="" src={editIcon} />
                      </button>
                      <button
                        type="button"
                        className="view-btn"
                        title="View"
                        onClick={() => {
                          navigate(`/impact-story/details/${s._id}`);
                        }}
                      >
                        <img alt="" src={viewIcon} />
                      </button>
                      <button
                        type="button"
                        className="delete-btn"
                        title="Delete"
                        onClick={() => {
                          setSelectedStory(s._id)
                          setShowModel(true);
                        }}
                      >
                        <img alt="" src={deleteIcon} />
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        {stories.length > 0 ? (
          <Pagination
            currentPage={pageNo}
            totalCount={totalData}
            pageSize={pageSize}
            onPageChange={(page) => setPageNo(page)}
            changePageSize={(page) => {
              setPageSize(page);
              setPageNo(1);
            }}
          />
        ) : (
          <></>
        )}
      </div>

      <Modal
        show={showModel}
        onHide={() => {
          setShowModel(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Impact Story</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this story ?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark"
            variant="secondary"
            onClick={() => {
              setShowModel(false);
            }}
          >
            No
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              handleDelete();
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImpactStory;
